import { useCallback } from 'react';

import { useUpdateMessage } from '@web/conversations/hooks/useUpdateMessage';
import { useConversationActions } from '@web/conversations/Conversation/ConversationProvider/ConversationProvider';
import { MessagePost } from '@web/conversations/types/Message';

type Props = {
  message: MessagePost;
};

export const useEditMessageAction = () => {
  const mutation = useUpdateMessage();
  const { updateMessage, setEditMessage } = useConversationActions();

  const { mutateAsync } = mutation;

  const action = useCallback(
    async ({ message }: Props) => {
      const { attachments, conversationId, id, content, parentMessage } = message;

      try {
        const updatedMessage = await mutateAsync({
          attachments,
          conversationId,
          content: content,
          messageId: id,
          parentMessage: parentMessage ? { id: parentMessage.id } : null,
        });

        updateMessage({
          message: updatedMessage,
        });
        setEditMessage({ messageId: null });
      } finally {
        // INFO we don't care about the result for some reason ;)
      }
    },
    [mutateAsync, setEditMessage, updateMessage]
  );

  return { action, mutation };
};
